import React, { Component } from 'react';
import { connect } from 'react-redux';

const CDN_URL = process.env.REACT_APP_CDN_URL;
const storageLoadingCube = `${CDN_URL}common/loading/storageLoadingCube.gif`;
const billingLoadingCube = `${CDN_URL}common/loading/billingLoadingCube.gif`;
const supportLoadingCube = `${CDN_URL}common/loading/supportLoadingCube.gif`;
const accountLoadingCube = `${CDN_URL}common/loading/profileLoadingCube.gif`;
const colocationLoadingCube = `${CDN_URL}common/loading/profileLoadingCube.gif`;

class LoadingCube extends Component {
	constructor(props) {
		super(props);

		this.state = {
			//expanded: false,
		};
	}
	getModuleLoadingCube = site => {
		const siteModule = site?.module;
		switch (siteModule) {
			case 'STORAGE':
				return storageLoadingCube;
			case 'SUPPORT':
				return supportLoadingCube;
			case 'BILLING':
				return billingLoadingCube;
			case 'ACCOUNT':
				return accountLoadingCube;
			case 'COLOCATION':
				return colocationLoadingCube;
			case 'COLO':
				return colocationLoadingCube;
			default:
				return supportLoadingCube;
		}
	};

	render() {
		const { site, padding } = this.props;
		return (
			<div className={padding ? 'loading-cube-wrapper padding' : 'loading-cube-wrapper'}>
				<img src={this.getModuleLoadingCube(site)} />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		site: state.site_tracking,
	};
}

export default connect(mapStateToProps, null)(LoadingCube);
